import { render } from "./AgeingTooltip.vue?vue&type=template&id=36fba283&scoped=true"
import script from "./AgeingTooltip.vue?vue&type=script&lang=js"
export * from "./AgeingTooltip.vue?vue&type=script&lang=js"

import "./AgeingTooltip.vue?vue&type=style&index=0&id=36fba283&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fba283"]])

export default __exports__